import { defineMessages } from 'react-intl'

const scope = `procurify.platform.legal-entities.features.list-legal-entities.views.legal-entity-list-view`

export default defineMessages({
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search',
  },
  searchAriaLabel: {
    id: `${scope}.searchAriaLabel`,
    defaultMessage: 'Search entities',
  },
  newEntityButton: {
    id: `${scope}.newEntityButton`,
    defaultMessage: 'New entity',
  },
  columnName: {
    id: `${scope}.columnName`,
    defaultMessage: 'Entity name',
  },
  columnBaseCurrency: {
    id: `${scope}.columnBaseCurrency`,
    defaultMessage: 'Base currency',
  },
  columnCountry: {
    id: `${scope}.columnCountry`,
    defaultMessage: 'Country',
  },
  columnExternalId: {
    id: `${scope}.columnExternalId`,
    defaultMessage: 'External ID',
  },
  noneAdded: {
    id: `${scope}.noneAdded`,
    defaultMessage: 'None added',
  },
  countActive: {
    id: `${scope}.countActive`,
    defaultMessage:
      '{count, plural, one {# active entity} other {# active entities}}',
  },
  countInactive: {
    id: `${scope}.countInactive`,
    defaultMessage:
      '{count, plural, one {# inactive entity} other {# inactive entities}}',
  },
  countActiveSearch: {
    id: `${scope}.countActiveSearch`,
    defaultMessage:
      'Found {matched} of {total, plural, one {# active entity} other {# active entities}}',
  },
  countInactiveSearch: {
    id: `${scope}.countInactiveSearch`,
    defaultMessage:
      'Found {matched} of {total, plural, one {# inactive entity} other {# inactive entities}}',
  },
  firstRunEmptyDescription: {
    id: `${scope}.firstRunEmptyDescription`,
    defaultMessage:
      'Add your entities into Procurify to match your financial structure.',
  },
  loadErrorTitle: {
    id: `${scope}.loadErrorTitle`,
    defaultMessage: 'We couldn’t load entities',
  },
  loadErrorMessage: {
    id: `${scope}.loadErrorMessage`,
    defaultMessage:
      'Refresh the page to try again. If the problem continues, contact support.',
  },
  emptyActiveTitle: {
    id: `${scope}.emptyActiveTitle`,
    defaultMessage: 'No active entities',
  },
  emptyInactiveTitle: {
    id: `${scope}.emptyInactiveTitle`,
    defaultMessage: 'No inactive entities',
  },
  emptySearchTitle: {
    id: `${scope}.emptySearchTitle`,
    defaultMessage: 'No entities found',
  },
  tableAriaLabel: {
    id: `${scope}.tableAriaLabel`,
    defaultMessage: 'Legal entities',
  },
  actionDisable: {
    id: `${scope}.actionDisable`,
    defaultMessage: 'Disable entity',
  },
  actionEnable: {
    id: `${scope}.actionEnable`,
    defaultMessage: 'Enable entity',
  },
  lastActiveEntityTooltip: {
    id: `${scope}.lastActiveEntityTooltip`,
    defaultMessage: 'Your organization needs at least one active entity.',
  },
})
